/**
 * Track Site Search Event
 */

import { logDebug, pushToAdobeDataLayer } from './utils';

export interface SiteSearchParams {
    /** Search term (required) */
    type: string;
    term: string;
}

export const trackSiteSearch = ({ type, term }: SiteSearchParams): void => {
    logDebug('Tracking site search...');
    const pathname = window.location.pathname;
    const payload = {
        event: 'siteSearch',
        _volvo: {
            universal: {
                web: {
                    search: {
                        term: term,
                        siteSearch: {
                            value: 1,
                        },
                        location: pathname,
                        type: type,
                    },
                },
            },
        },
        web: {
            webInteraction: {
                type: 'other',
            },
        },
    };
    void pushToAdobeDataLayer(payload);
};
